var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSelfSellCarIcon2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_21688",
    "data-name": "\\uADF8\\uB8F9 21688",
    transform: "translate(-910 -1678)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_27583",
    "data-name": "\\uC0AC\\uAC01\\uD615 27583",
    width: 40,
    height: 40,
    transform: "translate(910 1678)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_21687",
    "data-name": "\\uADF8\\uB8F9 21687"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_21390",
    "data-name": "\\uADF8\\uB8F9 21390",
    transform: "translate(911.164 1680.437)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_10113",
    "data-name": "\\uD328\\uC2A4 10113",
    d: "M33.553,38.35a3.507,3.507,0,0,0-2.756.072,4.329,4.329,0,0,0-2.275,1.568,13.775,13.775,0,0,0-1.054,2.67,1.2,1.2,0,0,1-2.067.373,10.53,10.53,0,0,1-.783-2.116A4.479,4.479,0,0,0,20.764,38.1,6.387,6.387,0,0,0,17.5,39.126a2.388,2.388,0,0,1-.931.35,1.393,1.393,0,0,1-1.229-1.229,2.373,2.373,0,0,1,.351-.931c.2-.424.411-.845.608-1.273a4.573,4.573,0,0,0-.786-4.838,6.444,6.444,0,0,0-2.858-1.456c-.818-.292-1.716-.749-1.209-1.856.305-.665,1.5-.832,2.112-1.05a6.731,6.731,0,0,0,1.174-.488,4.259,4.259,0,0,0,1.662-2.34,4.37,4.37,0,0,0-.434-3.852c-.442-.925-1.1-1.739.01-2.5a.966.966,0,0,1,1.069-.09c.478.21.946.451,1.418.677a4.994,4.994,0,0,0,1.8.577,5.388,5.388,0,0,0,2.916-.874c1.182-.728,1.512-2.114,1.947-3.332a1.762,1.762,0,0,1,.549-1,1.293,1.293,0,0,1,1.647.263,10.472,10.472,0,0,1,.822,2.224c.551,1.542,3.029.878,2.472-.682-.254-.71-.491-1.428-.761-2.131a3.747,3.747,0,0,0-4.523-2.28,3.971,3.971,0,0,0-2.676,2.921c-.419,1.173-.538,2.026-1.964,2.306-.714.14-1.7-.59-2.457-.937a3.708,3.708,0,0,0-4.635,1.137c-1.114,1.346-.869,2.867-.174,4.321.217.454.468.906.656,1.374a.881.881,0,0,1,.1.474,3.161,3.161,0,0,1-.534,1.364,1.885,1.885,0,0,1-.884.442c-.483.173-.97.336-1.448.518a3.737,3.737,0,0,0,.124,7.093c.7.258,1.926.411,2.324,1.113.738,1.3.186,1.92-.4,3.138a3.779,3.779,0,0,0,4.977,5.282c.433-.2.863-.413,1.295-.618a1.481,1.481,0,0,1,1.578-.059,1.462,1.462,0,0,1,1.046,1c.185.519.364,1.041.556,1.557a3.741,3.741,0,0,0,4.373,2.5c1.7-.3,2.417-1.63,2.942-3.1A10.013,10.013,0,0,1,30.6,41.5a1.969,1.969,0,0,1,2.275-.681,1.29,1.29,0,0,0,1.577-.9,1.313,1.313,0,0,0-.895-1.576",
    transform: "translate(-8.802 -10.884)",
    fill: "#343a40",
    stroke: "#fff",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_10114",
    "data-name": "\\uD328\\uC2A4 10114",
    d: "M29.254,31.353A7.3,7.3,0,0,1,18.93,21.029a7.163,7.163,0,0,1,5.723-2.067",
    transform: "translate(-6.54 -8.617)",
    fill: "none",
    stroke: "#343a40",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_10115",
    "data-name": "\\uD328\\uC2A4 10115",
    d: "M37.255,17.306V12.172a.562.562,0,0,1,.952-.408c1.985,1.948,5.856,7.012-.734,12.225a.556.556,0,0,0-.218.434V41.239a1.833,1.833,0,0,1-1.837,1.833h-2a1.838,1.838,0,0,1-1.838-1.837V24.429a.569.569,0,0,0-.217-.44c-6.592-5.213-2.72-10.277-.736-12.225a.562.562,0,0,1,.952.408v5.135a.565.565,0,0,0,.341.518L34.2,18.8a.57.57,0,0,0,.445,0l2.274-.975A.565.565,0,0,0,37.255,17.306Z",
    transform: "translate(-3.484 -10.682)",
    fill: "none",
    stroke: "#343a40",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_1225",
    "data-name": "\\uD0C0\\uC6D0 1225",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(926 1695)",
    fill: "#ff6a13"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelfSellCarIcon2);
export default __webpack_public_path__ + "static/media/SelfSellCarIcon2.87a668498ec79aa95b0cf37bc6a52aac.svg";
export { ForwardRef as ReactComponent };